import React, { Component } from "react";
import { Routes, Route } from "react-router-dom";
import Dashboard from "../components/Dashboard";
import Certificates from "../components/Certificates";
import Certificate from "../components/Certificate";
import Transactions from "../components/Transactions";
import UpperPage from "../components/UpperPage";

class DashboardContainer extends Component {
  render() {
    return (
      <div className="grey-bg">
        <div className="dashboard-container">
          <UpperPage />
          <div className="dashboard-inner">
            <Routes>
              <Route index element={<Dashboard />} />
              <Route path="certificates" element={<Certificates />} />
              <Route path="transactions" element={<Transactions />} />
              <Route path="certificates/:id" element={<Certificate />} />
            </Routes>
          </div>
        </div>
      </div>
    );
  }
}

export default DashboardContainer;
